function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  // routes:
  // /settings/filters
  // /settings/filters/:filterId
  //
  // services:
  // FilterPermissionSvc
  //
  // controllers:
  // FilterSettingsCtrl
  // FilterAssocReportsModalCtrl
  // FilterListCtrl
  // FilterPermissionsCtrl
  // FilterCategoryModalCtrl
  // FilterMenuSequenceCtrl
  // FilterEditorCtrl -- ./controllers/filter-editor.js
  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/filters', {
      templateUrl: 'modules/app/settings/filters/filter-settings.html',
      controller: 'FilterSettingsCtrl',
      requiredPermissions: ['admin', 'manager']
    }).when('/settings/filters/:filterId', {
      templateUrl: 'modules/app/settings/filters/filter-editor.html',
      controller: 'FilterEditorCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).service('FilterPermissionSvc', ['$q', 'AppPermissions', 'CustomFilters', 'Logger', function ($q, AppPermissions, CustomFilters, Logger) {
    var self = {
      __filters: null,
      __permissionMap: null,
      fetch: function fetch() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            countReports: false
          },
          _limit = _ref._limit,
          _offset = _ref._offset,
          countReports = _ref.countReports,
          searchText = _ref.searchText,
          order_by = _ref.order_by;
        return CustomFilters.list({
          _limit: _limit,
          _offset: _offset,
          countReports: countReports,
          searchText: searchText,
          order_by: order_by
        }).then(function getFiltersSuccess(data) {
          self.__filters = data.results;
          return self.fetchPermissions().then(function getPermissionsSuccess() {
            // map permissions onto each filter object
            _.each(self.__filters, function (filter) {
              filter.permissions = self.get(filter.id);
            });
            return {
              count: data.count,
              filters: self.__filters
            };
          });
        }, function getFiltersError(response) {
          self.__filters = null;
          Logger.error("filters fetch failed with response status " + response.status);
          return [];
        });
      },
      fetchPermissions: function fetchPermissions() {
        if (!self.__permissionMap) {
          self.__permissionMap = {};
          return AppPermissions.getPermissions('filter').then(function getPermissionsSuccess(filterPermissions) {
            self.__permissionMap = filterPermissions;
          });
        } else {
          return $q.resolve();
        }
      },
      get: function get(id) {
        return {
          permissions: self.getPermissions(id),
          people: self.getPeople(id),
          groups: self.getGroups(id),
          hasGlobalGroup: self.getHasGlobalGroup(id)
        };
      },
      getPermissions: function getPermissions(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].permissions : [];
      },
      getPeople: function getPeople(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].people : [];
      },
      getGroups: function getGroups(id) {
        return _.has(self.__permissionMap, id) ? self.__permissionMap[id].groups : [];
      },
      getHasGlobalGroup: function getHasGlobalGroup(id) {
        return !_.isUndefined(_.find(self.getGroups(id), function (g) {
          return g.id === -1;
        }));
      },
      save: function save(id, permissions, people, groups) {
        var entityParams = {
          value: 'filter',
          entityId: id
        };
        return AppPermissions.multiSave(permissions, {
          params: entityParams
        }).then(function saveFilterPermissionsSuccess() {
          return self.set(id, permissions, people, groups);
        }, function saveFilterPermissionsError(response) {
          Logger.error("Error updating filter permissions, response status " + response.status);
          return {};
        });
      },
      set: function set(id, permissions, people, groups) {
        if (!_.has(self.__permissionMap, id)) {
          if (!self.__permissionMap) {
            self.__permissionMap = {};
          }
          self.__permissionMap[id] = {
            permissions: [],
            people: [],
            groups: []
          };
        }
        var entityPermissions = self.__permissionMap[id];
        if (_.isArray(permissions)) {
          entityPermissions.permissions = permissions;
        }
        if (_.isArray(people)) {
          entityPermissions.people = _.sortBy(people, 'name');
        }
        if (_.isArray(groups)) {
          entityPermissions.groups = _.sortBy(groups, 'name');
        }
        return entityPermissions;
      },
      remove: function remove(id) {
        delete self.__permissionMap[id];
      },
      updateFilters: function updateFilters() {
        CustomFilters.update();
        return self.fetch();
      }
    };
    return self;
  }]).controller('FilterSettingsCtrl', ['$scope', 'UserRoles', 'User', function ($scope, UserRoles, User) {
    $scope.section = 'filters';
    $scope.isAreaAdmin = UserRoles.isOrgAdmin(User.get());
  }]).controller('FilterAssocReportsModalCtrl', ['$scope', 'CustomFilters', 'CardUtils', '$location', function ($scope, CustomFilters, CardUtils, $location) {
    $scope.CardUtils = CardUtils;
    $scope.navigateToReport = function (report) {
      $scope.$close();
      $location.path("/".concat(report.template.name, "/").concat(report.id));
    };
    CustomFilters.get($scope.filterForAssociatedReports.id).then(function (_ref2) {
      var reports = _ref2.reports;
      $scope.reports = reports;
    });
  }]).controller('FilterListCtrl', ['$scope', '$q', '$http', '$uibModal', 'Api', 'FilterPermissionSvc', 'wsEventNames', 'ConfirmModal', 'FilterRegistry', function ($scope, $q, $http, $uibModal, Api, FilterPermissionSvc, wsEventNames, ConfirmModal, FilterRegistry) {
    $scope.$emit('headline:change', 'Settings');
    $scope.$emit('nav:change', 'settings');
    $scope.section = 'filters';
    $scope.filters = [];
    $scope.sortControls = [{
      "title": "Filter",
      "options": {
        "Name Ascending": "name",
        "Name Descending": "-name"
      }
    }, {
      "title": "Reports"
    }, {
      "title": "View Permission"
    }, {
      "title": "Category",
      "options": {
        "Filter Category Name Ascending": "filterCategory.name",
        "Filter Category Name Descending": "-filterCategory.name"
      }
    }, {
      "title": "Updated",
      "options": {
        "Last Updated Ascending": "updated",
        "Last Updated Descending": "-updated"
      }
    }];
    $scope.sortBy = 'name';
    $scope.defaultSortBy = 'name';
    $scope.useLegacySearchParams = true;
    $scope.loadAssociatedReports = function loadAssociatedReports(filter) {
      $scope.filterForAssociatedReports = filter;
      return $uibModal.open({
        templateUrl: 'modules/app/settings/filters/modals/associated-reports.html',
        controller: 'FilterAssocReportsModalCtrl',
        scope: $scope
      });
    };
    $scope.deleteFilter = function deleteFilter(filter) {
      var body, confirmBtn;
      if (filter.reportCount) {
        body = "This will remove this filter from the ".concat(filter.reportCount, " report").concat(filter.reportCount > 1 ? 's' : '', " it is used on. Are you sure?");
        confirmBtn = "Delete and remove from reports";
      } else {
        body = "Are you sure?";
        confirmBtn = "Delete";
      }
      var deleteModal = {
        title: "Delete Custom Filter ".concat(filter.name),
        body: body,
        cancelBtn: "Cancel",
        confirmBtn: confirmBtn,
        confirm: function confirm() {
          $http.delete(Api.url("/filters/".concat(filter.id)))
          // refresh ui
          .then(function () {
            FilterRegistry.removeFilter(filter);
            $scope.setFilterPage(0);
          });
        },
        cancel: function cancel() {}
      };
      ConfirmModal.open($scope, deleteModal);
    };
    $scope.isLoading = false;
    $scope.fetchData = function fetchData(params) {
      $scope.isLoading = true;
      var defer = $q.defer();
      var _params = Object.assign({}, params, {
        searchText: params.searchTerm || '',
        countReports: true
      });
      return FilterPermissionSvc.fetch(_params).then(function (_ref3) {
        var count = _ref3.count,
          filters = _ref3.filters;
        $scope.isLoading = false;
        $scope.filters = filters;
        defer.resolve({
          count: count
        });
        return defer.promise;
      });
    };
    $scope.fetchFilterPage = function (offset, limit) {
      $scope.isLoading = true;
      var params = {
        _limit: limit,
        _offset: offset,
        countReports: true,
        searchText: $scope.search.name
      };
      var defer = $q.defer();
      return FilterPermissionSvc.fetch(params).then(function (_ref4) {
        var count = _ref4.count,
          filters = _ref4.filters;
        $scope.isLoading = false;
        $scope.filters = filters;
        defer.resolve({
          count: count
        });
        return defer.promise;
      });
    };
    var prevSearchTerm = '';
    $scope.updateSearchTerm = function updateSearchTerm() {
      if ($scope.searchTerm !== prevSearchTerm) {
        $scope.$broadcast(wsEventNames.pager.setPage, 1);
        prevSearchTerm = $scope.searchTerm;
      }
    };
    $scope.setFilterPage = function setFilterPage() {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      $scope.$broadcast(wsEventNames.pager.setPage, p);
    };
    $scope.formatPermissionsDisplay = function (d) {
      if (typeof d === 'undefined') {
        // is this the right behavior for this case?
        return "All groups and people";
      }
      if (d.hasGlobalGroup) {
        return "All groups and people";
      }
      var groupDisplay, peopleDisplay;
      if (d.groups && d.groups.length > 0) {
        var len = d.groups.length;
        groupDisplay = "".concat(len, " group").concat(len > 1 ? 's' : '');
      }
      if (d.people && d.people.length > 0) {
        var _len = d.people.length;
        peopleDisplay = "".concat(_len, " ").concat(_len > 1 ? 'people' : 'person');
      }
      if (groupDisplay && peopleDisplay) {
        return "".concat(groupDisplay, ", ").concat(peopleDisplay);
      }
      return groupDisplay || peopleDisplay;
    };
  }]).controller('FilterPermissionsCtrl', ['$scope', '$controller', '$q', '$http', 'Api', 'FilterPermissionSvc', 'Alerts', 'People', function ($scope, $controller, $q, $http, Api, FilterPermissionSvc, Alerts, People) {
    $scope.searchPlaceholder = "Search for a person or group to see their Filter Permissions";
    $scope.permissionEntitySelected = function (entity) {
      $scope.loading = true;
      // Get the categories and groups for the selected person/group
      var cfg = {
        value: "filter"
      };
      $scope.entityId = entity.id;
      $scope.originalEntity = angular.copy(entity);
      var dataCalls;
      if (entity.personas) {
        cfg.personId = entity.id;
        $scope.isPerson = true;
        dataCalls = $q.all([FilterPermissionSvc.fetch(), People.getPeopleWithMemberships({
          params: {
            id: entity.id
          }
        })]);
      } else {
        cfg.groupId = entity.id;
        $scope.isPerson = false;
        dataCalls = $q.all([FilterPermissionSvc.fetch()]);
      }
      dataCalls.then(function (responses) {
        $scope.filters = responses[0].filters || [];
        $scope.isOrgAdmin = false;
        if (responses.length > 1) {
          var userWithMemberships = responses[1];
          if (userWithMemberships.count === 1 && userWithMemberships.results[0].membership && userWithMemberships.results[0].membership.role === "admin") {
            $scope.isOrgAdmin = true;
          }
        }
        // Clear out all permission info when cached locally
        _.each($scope.filters, function (f) {
          delete f.hasPermission;
          delete f.directPermission;
        });
        if (!$scope.isOrgAdmin) {
          var url;
          if ($scope.isPerson) {
            url = Api.url("/people/" + $scope.entityId + "/app-permissions?value=filter");
          } else {
            url = Api.url("/groups/" + $scope.entityId + "/app-permissions/include-implicit?value=filter");
          }

          // Decorate the filters objects with permission info from the selected person/group
          $http.get(url).then(function (response) {
            var filterPermissions = response.data;
            $scope.permittedFiltersCount = filterPermissions.length;
            $scope.indirectPermittedFiltersCount = 0;
            _.forEach(filterPermissions, function (filterPermission) {
              // Find the filter
              var filter = _.findWhere($scope.filters, {
                id: filterPermission.entityId
              });
              if (filter !== undefined && filter !== null) {
                filter.hasPermission = true;
                if ($scope.isPerson && filterPermission.personId && filterPermission.personId === $scope.entityId) {
                  filter.directPermission = true;
                } else if (!$scope.isPerson && filterPermission.groupId && filterPermission.groupId === $scope.entityId) {
                  filter.directPermission = true;
                } else {
                  $scope.indirectPermittedFiltersCount++;
                }
              }
            });
            var _cols = 3;
            $scope.filterRows = makeRows($scope.filters, _cols);
            $scope.loading = false;
          });
        }
      });
    };
    $scope.save = function () {
      var permittedFilterIds = [];
      _.forEach($scope.filters, function (filter) {
        if (filter.directPermission) {
          permittedFilterIds.push(filter.id);
        }
      });
      $http.post(Api.url("/app-permissions/update-filter-permissions?_limit=1000&" + ($scope.isPerson ? "personId=" : "groupId=") + $scope.entityId), {
        entityId: $scope.entityId,
        filterIds: permittedFilterIds
      }).then(function success() {
        updateCachedPermissions($scope.originalEntity, $scope.isPerson, permittedFilterIds);
        Alerts.raiseAlert({
          type: "success",
          text: $scope.permissionEntity.name + " filter permissions updated"
        });
      });
    };
    function updateCachedPermissions(entity, isPerson, permittedFilterIds) {
      _.each(FilterPermissionSvc.__permissionMap, function (permission, filterId) {
        filterId = parseInt(filterId);
        // Add if missing
        if (_.contains(permittedFilterIds, filterId)) {
          if (!_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              if (!Array.isArray(permission.peopleIds)) {
                permission.peopleIds = [];
              }
              permission.peopleIds.push(entity.id);
              if (!Array.isArray(permission.people)) {
                permission.people = [];
              }
              permission.people.push(entity);
            } else {
              if (!Array.isArray(permission.groupIds)) {
                permission.groupIds = [];
              }
              permission.groupIds.push(entity.id);
              if (!Array.isArray(permission.groups)) {
                permission.groups = [];
              }
              permission.groups.push(entity);
            }
          }
        } else {
          // remove if needed
          if (_.contains(isPerson ? permission.peopleIds : permission.groupIds, entity.id)) {
            if (isPerson) {
              permission.peopleIds = _.without(permission.peopleIds || [], entity.id);
              permission.people = _.filter(permission.people || [], function (person) {
                return person.id !== entity.id;
              });
            } else {
              permission.groupIds = _.without(permission.groupIds || [], entity.id);
              permission.groups = _.filter(permission.groups || [], function (group) {
                return group.id !== entity.id;
              });
            }
          }
        }
      });
    }
    $scope.cancel = function () {
      $scope.permissionEntity = null;
    };
    function makeRowPartition(count, cols) {
      var _d = Math.floor(count / cols);
      var _r = count % cols;
      return Array.from({
        length: cols
      }, function (_, i) {
        return i < _r ? _d + 1 : _d;
      }).reduce(function (a, x) {
        return [a[0] + x].concat(_toConsumableArray(a));
      }, [0]).reverse().reduce(function (a, x, i, arr) {
        return [].concat(_toConsumableArray(a), [typeof arr[i + 1] === 'undefined' ? undefined : [x, arr[i + 1]]]);
      }, []).filter(function (x) {
        return x !== undefined;
      });
    }
    function makeRows(arr, cols) {
      return makeRowPartition(arr.length, cols).map(function (part) {
        return arr.slice.apply(arr, _toConsumableArray(part));
      });
    }
  }]).controller('FilterCategoriesCtrl', ['$scope', '$controller', '$q', '$http', 'Api', '$timeout', 'wsEventNames', '$filter', 'ConfirmModal', '$uibModal', function ($scope, $controller, $q, $http, Api, $timeout, wsEventNames, $filter, ConfirmModal, $uibModal) {
    $scope.addEditCategory = function addEditCategory(category) {
      var scope = $scope.$new();
      scope.cat = category;
      $uibModal.open({
        templateUrl: 'modules/app/settings/filters/modals/add-edit-category.html',
        // todo
        controller: 'FilterCategoryModalCtrl',
        // todo
        backdrop: 'static',
        scope: scope
      });
    };
    $scope.deleteCategory = function deleteCategory(cat) {
      var deleteModal = {
        title: "Delete Filter Category " + cat.name,
        body: "Are you sure you want to delete " + cat.name + "?",
        cancelBtn: "Cancel",
        confirmBtn: "Delete",
        confirm: function confirm() {
          $http.delete(Api.url("/filter-categories/" + cat.id)).then(function () {
            // todo
            //refresh UI
            $scope.setCategoryPage(0);
          });
        },
        cancel: function cancel() {}
      };
      ConfirmModal.open($scope, deleteModal);
    };
    $scope.fetchCategoryPage = function (offset, limit) {
      $scope.limit = limit || 10;
      $scope.offset = offset || 0;
      var defer = $q.defer();
      return $http.get(Api.url("/filter-categories")).then(
      // todo
      function (response) {
        $scope.categories = response.data.results;
        defer.resolve({
          count: $filter('filter')($scope.categories, $scope.search).length
        });
        return defer.promise;
      });
    };
    $scope.setCategoryPage = function setCategoryPage() {
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      $scope.$broadcast(wsEventNames.pager.setPage, p);
    };
    $scope.search = {};
    $scope.$watch('search.name', function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    });
    $scope.formatCategoryFilterTooltip = function (cat) {
      var html = "<p><strong>Filter Category " + cat.name + " is associated<br/> with the following filters:</strong></p>";
      _.each(cat.filters, function (m) {
        html += m.name + "<br/>";
      });
      return html;
    };
    $scope.$on("category-added-event", function categoryAdded() {
      // todo
      $scope.$broadcast(wsEventNames.pager.setPage, "last");
    });
  }]).controller('FilterCategoryModalCtrl', ['$scope', '$uibModalInstance', 'CardGroup', 'Logger', 'FilterPermissionSvc', 'User', 'Validation', 'wsEventNames', 'UserRoles', 'GroupUtils', '$http', 'Api', function ($scope, $uibModalInstance, CardGroup, Logger, PermissionSvc, User, Validation, wsEventNames, UserRoles, GroupUtils, $http, Api) {
    $scope.action = "Add";
    var user = User.get();
    $scope.newCategory = {
      name: "",
      organization: user.organization,
      id: null
    };
    if ($scope.cat) {
      _.extend($scope.newCategory, $scope.cat);
      $scope.action = "Edit";
    }
    $scope.priorName = $scope.newCategory.name;
    $scope.save = function save() {
      $scope.saveCategoryError = null;
      $scope.saveCategoryProgress = "Saving changes to  " + $scope.newCategory.name + "...";
      $scope.sending = true;
      $scope.categoryFormErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.newCategory.name
        }
      });
      if ($scope.categoryFormErrors !== null) {
        $scope.saveCategoryProgress = null;
        $scope.sending = false;
        return;
      }
      function saveCategoryError(response) {
        $scope.saveCategoryProgress = null;
        Logger.error("Error " + $scope.action.toLowerCase() + "ing filter category " + $scope.newCategory.name + ", response status " + response.status);
        $scope.saveCategoryError = "There was error " + $scope.action.toLowerCase() + "ing the filter category";
        if (response.status === 409) {
          $scope.saveCategoryError = "A filter category with this name already exists in your" + " organization";
        }
        $scope.sending = false;
      }

      // If there's an id, this is an update, otherwise we are creating with a POST
      if ($scope.newCategory.id) {
        $http.put(Api.url("/filter-categories/" + $scope.newCategory.id), $scope.newCategory).then(
        // todo
        function saveCategorySuccess() {
          $uibModalInstance.close();
          $scope.cat.name = $scope.newCategory.name;
          return;
        }, saveCategoryError);
      } else {
        $http.post(Api.url("/filter-categories"), $scope.newCategory).then(
        // todo
        function saveCategorySuccess(createdCategory) {
          // update displayed category object with new values
          if ($scope.cat) {
            _.extend($scope.cat, createdCategory);
          }
          $scope.$emit("category-added-event");
          $uibModalInstance.close();
          return;
        }, saveCategoryError);
      }
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]).controller('FilterMenuSequenceCtrl',
  // ['$scope', '$controller', '$q', '$http', 'Api', 'Filters', 'Alerts', // todo: add Filters service
  //     function ($scope, $controller, $q, $http, Api, Filters 'Alerts', // todo:
  ['$scope', '$controller', '$q', '$http', 'Api', 'Alerts', 'CustomFilters', function ($scope, $controller, $q, $http, Api, Alerts, CustomFilters) {
    $http.get(Api.url("/filter-categories")).then(function (response) {
      // We only want non-empty categories here
      $scope.categories = response.data.results;

      //TODO: Do these parallel
      CustomFilters.getAll({
        countReports: true
      }).then(function (filters) {
        $scope.filters = filters.results;

        // Pull out top level menu items
        var menuItems = _.filter($scope.filters, function (f) {
          return f.filterCategoryName === "None";
        });
        menuItems = menuItems.concat($scope.categories);
        menuItems = _.sortBy(menuItems, 'menuPosition');

        // Yes, we are calling categories "filters" at the top level here just
        // for consistency -- at the top level it can be either filters or categories
        var topLevelMenu = {
          name: "Filter Menu",
          filters: menuItems,
          id: -1,
          isMainMenu: true
        };
        $scope.menuItems = [topLevelMenu];
        $scope.selectedMenu = topLevelMenu; // default upon load

        // Add all the categories as well
        $scope.menuItems = $scope.menuItems.concat($scope.categories);
      });
      $scope.$watch('selectedMenu.filters', function (newItem, oldItem) {
        // IF the change was simply due to selecting a different change, don't persist.  We
        // are just interested in ordering changes
        if (!newItem || !oldItem || newItem.id !== oldItem.id) {
          return;
        }
        var orderMatches = true;
        var hasUninitializedMenuItem = false;
        if (newItem.length !== oldItem.length) {
          return;
        }
        for (var i = 0; i < newItem.length; i++) {
          orderMatches = orderMatches && newItem[i].menuPosition !== 0 && newItem[i].menuPosition === oldItem[i].menuPosition;
        }
        for (var j = 0; j < newItem.length; j++) {
          if (newItem[j].menuPosition === 0) {
            hasUninitializedMenuItem = true;
            break;
          }
        }
        if (orderMatches && !hasUninitializedMenuItem) {
          return;
        }
        if ($scope.selectedMenu.isMainMenu) {
          $http.put(Api.url("/filters/update-filter-order"), $scope.selectedMenu).then(
          // todo
          function saveCategorySuccess() {
            if (!hasUninitializedMenuItem) {
              Alerts.raiseAlert({
                type: "success",
                text: "Filter order updated."
              });
            }
          });
        } else {
          $http.put(Api.url("/filter-categories/" + $scope.selectedMenu.id), $scope.selectedMenu).then(function saveCategorySuccess() {
            if (!hasUninitializedMenuItem) {
              Alerts.raiseAlert({
                type: "success",
                text: "Filter order updated."
              });
            }
          });
        }
      }, true);
    });
    $scope.alphabetize = function () {
      $scope.selectedMenu.filters = _.sortBy($scope.selectedMenu.filters, function (item) {
        return item.name.toLowerCase();
      });
    };
  }]);
})();
